import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { ReactNode } from "react";
import { ModalProps } from "types/utils/modal";

export const DeleteConfirm = ({
  isOpen,
  close,
  isLoading,
  onConfirm,
  description,
}: ModalProps & {
  isLoading: boolean;
  onConfirm: () => void;
  description: ReactNode;
}) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <StatusModal type="warning" title="Delete document?">
          {description}
        </StatusModal>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Cancel</Button>
          </Modal.RawClose>
          <Button
            isLoading={isLoading}
            disabled={isLoading}
            customType="danger"
            onClick={onConfirm}
          >
            Yes, delete
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
